
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import BsSpinner from 'react-bootstrap/Spinner';
import { useTranslation } from "react-i18next";
import BboxViewer from '../components/BboxViewer';
import BreadNav from '../components/BreadNav';
import ErrorToast from '../components/ErrorToast';
import MyDropzone from '../components/MyDropzone';
import { ConnectionShapeSelector, CountrySelector, ScrewdriverShapeSelector, YearRangeSelector, YearSelector } from '../components/Selectors';
import { checkQuality, createIdentification, getIdImage, getIdentification, updateIdentification, updateOrCreateIdImage } from '../services';
import { buildUrl, context } from '../utils';



const InlineForm = ({ label, isRequired, children, helptext }) => {
    return <div className="form-group row">
        <label className="col-form-label col-sm-4 requiredField">
            {label}
            {isRequired ? <span className="asteriskField">*</span> : ''}
        </label>

        <div className="field-col col-sm-8">
            {children}

            <small className="form-text text-muted">{helptext}</small>
        </div>
    </div>;
};

const requestId = JSON.parse((document.getElementById('__request_id') || {}).textContent || null);

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const IdentificationForm = () => {
    const { t } = useTranslation();

    const [instance, setInstance] = useState({});

    const [selectedFileIdx, setSelectedFileIdx] = React.useState();

    const [files, setFiles] = React.useState([]);

    const [isLoading, setIsLoading] = React.useState(false);


    const [formData, setFormData] = React.useState({});

    const [yearUnknown, setYearUnknown] = React.useState(false);

    const [errors, setErrors] = React.useState(null);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const hasPreview = true; //urlParams.get('preview') === "true";


    const selectedFile = files[selectedFileIdx] || {};
    const fooFiles = files;
    const setField = (name, value) => {
        setFormData(prev => ({

            ...prev,
            [name]: value,
        }));
    };

    const onSubmit = async () => {

        setIsSubmitting(true);
        const isEditing = Boolean(instance.id);
        let inst;

        try {
            if (isEditing) {
                inst = await updateIdentification(formData);
            } else {
                inst = await createIdentification(formData);
            }
        } catch (errors) {
            setErrors(errors);
            setIsSubmitting(false);
            return;
        }

        const requestId = instance.id || inst.id;

        try {
            await Promise.all(files.map(file => updateOrCreateIdImage({
                file: file,
                id: file.id,
                request_id: requestId,
                bboxes: file.bboxes,
                tags: file.tags,
            })));
        } catch (errors) {
            setErrors({
                [t("Images")]: t("Error submitting images")
            });
            setIsSubmitting(false);
        }


        const next = isEditing ? `/${context.current_language}/account/identifications/`
            : `/${context.current_language}/identification/${requestId}/payment-options`;

        const redirectUrl = context.user_id ? next : buildUrl(`/${context.current_language}/auth/signup/`, {
            email: formData.email,
            from: "id",
            request_id: requestId,
            next,
        });
        window.location.replace(redirectUrl);

    };
    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    const onSelectedFileIdx = async fileIdx => {
        let localFiles = [];
        await timeout(50);
        setFiles(files => {
            localFiles = files;
            return files;
        });

        setSelectedFileIdx(fileIdx);


        if (!localFiles[fileIdx].bboxes && hasPreview) {

            setIsLoading(true);
            let qualityData = {};
            try {
                qualityData = await checkQuality(localFiles[fileIdx]);
            } catch (e) {

            }
            setFiles(files => {
                files[fileIdx].tags = qualityData.qa_tags || [];

                if (qualityData.bboxes && qualityData.bboxes.length === 1) {
                    qualityData.bboxes[0].selected = true;
                }
                files[fileIdx].bboxes = qualityData.bboxes || [];
                return files;
            });

            setIsLoading(false);
            setSelectedFileIdx(undefined);
            setSelectedFileIdx(fileIdx);
        }
    };

    const onYearUnknownChange = (val) => {
        setYearUnknown(Boolean(val));
        if (val) {


            setField("year", undefined);
        }
    };

    const onBboxChange = async (bboxes) => {
        setFiles(prev => {
            prev[selectedFileIdx].bboxes = bboxes;

            return prev;
        });

        await timeout(10);
        setSelectedFileIdx(undefined);
        setSelectedFileIdx(selectedFileIdx);
    };

    const initialImageId = urlParams.get('iid');

    useEffect(() => {

        async function handle() {

            if (requestId) {
                const data = await getIdentification(requestId);
                setInstance(data);
                setFormData({
                    id: data.id,
                    comment: data.comment,
                    connection_shape: data.connection_shape,
                    country: data.country,
                    email: data.email,
                    screwdriver_shape: data.screwdriver_shape,
                    site_number: data.site_number,
                    year: data.year,
                    year_range: data.year_range,
                });

                setYearUnknown(Boolean(data.year_range));

                if (data.images) {


                    const promises = data.images.map(formatRemoteImage);

                    const formattedFiles = await Promise.all(promises);
                    onDropZoneFilesChange(formattedFiles);
                    setSelectedFileIdx(0);
                }


            } else if (initialImageId) {
                setIsLoading(true);
                const imgInstance = await getIdImage(initialImageId);
                if (!imgInstance.request) {
                    const formatted = await formatRemoteImage(imgInstance);

                    onDropZoneFilesChange([formatted]);

                    setSelectedFileIdx(0);
                    if (hasPreview) {

                        let qualityData = {};
                        try {
                            qualityData = await checkQuality(formatted);
                        } catch (e) {

                        }

                        if (qualityData.bboxes && qualityData.bboxes.length === 1) {
                            qualityData.bboxes[0].selected = true;
                        }
                        const newSelectedFile = {
                            ...formatted,
                            name: imgInstance.name,
                            tags: qualityData.qa_tags || [],
                            bboxes: qualityData.bboxes || [],
                        };
                        setFiles([newSelectedFile]);

                        setSelectedFileIdx(0);
                    }
                }
                setIsLoading(false);
            }
        }

        handle();
    }, []);


    const onDropZoneFilesChange = data => {
        setFiles(data);
    };

    const onQualityWarningClose = () => {
        setFiles(prev => {
            prev[selectedFileIdx].closedQualityWarning = true;
            return prev;
        });
    };


    const formDisabled = !files.length || !formData.country || !(formData.year || formData.year_range) || !formData.email;


    const selectedBoxesCount = (selectedFile.bboxes || []).filter(x => x.selected).length;
    const boxesCount = (selectedFile.bboxes || []).length;

    const showMultipleWarning = boxesCount > 1 && selectedBoxesCount <= 0;


    const isDemo = urlParams.get('demo') === "1";
    return <div>
        {!context.has_widget ?
            <BreadNav>
                {/* <li className="breadcrumb-item"><a href={context.urls.home}>{t("Home")}</a></li> */}


                {instance.id ? <>
                    <li className="breadcrumb-item"><a href={context.urls.identification_list}>{t("Identifications")}</a></li>
                    <li className="breadcrumb-item active" aria-current="page">{instance.id.slice(0, 6)}</li>
                    <li className="breadcrumb-item active" aria-current="page">{t('Edit')}</li>
                </>
                    :
                    <><li className="breadcrumb-item"><a href={context.urls.dental_implant_identification}>{t("Identification")}</a></li>
                        <li className="breadcrumb-item active" aria-current="page">{t('Implant Identification Request')}</li>
                    </>
                }
            </BreadNav> : ''}

        <ErrorToast errors={errors} />

        <div className="container narrow-container identification-form" style={{ marginBottom: "100px" }}>
            <h1 className="identification-title">
                {instance.id ? <>{t("Edit Identification")} <small>{instance.id.slice(0, 6)}</small></> : t("Implant Identification Request")}
            </h1>
            {urlParams.get('from') !== "implant_identification_page" && !(instance && instance.id) && context.app_context !== "desktop_app" ?
                <p>{t('Upload the radiograph of an unknown dental implant, our AI will identify it.')} <a href={context.urls.dental_implant_identification}>{t('Learn more')}</a></p>
                : ''}

            {selectedFile && selectedFile.blob ?
                <>

                    <div className="image-detect-preview">
                        {showMultipleWarning ? <div className="alert alert-primary image-warning">
                            <span className="badge badge-pill badge-primary"><span className="oi oi-info"></span></span>
                            <b>{t('Click on the implants you want to identify:')}</b>
                        </div> : ''}

                        <BboxViewer src={selectedFile.blob} isLoading={isLoading} bboxes={selectedFile.bboxes || []} onChange={onBboxChange} />

                    </div>
                    <div>
                        {!selectedFile.closedQualityWarning ?
                            <QualityWarning tags={selectedFile.tags || []} showMultipleWarning={showMultipleWarning} onClose={onQualityWarningClose} /> : ''}
                    </div>
                </>

                : ''}

            {!selectedFile && initialImageId ? <div className="image-detect-preview"></div> : ''}

            <MyDropzone files={files} onChange={onDropZoneFilesChange} onSelectedFileIdx={onSelectedFileIdx} onSelected={() => { }} />


            <div className="alert alert-primary image-warning image-guidelines" role="alert">
                <span className="badge badge-pill badge-primary"><span className="oi oi-info"></span></span>
                <span>{t('Image submission guidelines:')}</span>
                <ul>
                    <li>{t('Prefer intraoral periapical radiographs, avoid panoramic')}</li>
                    <li>{t('No pictures from smartphone, direct image export or computer screenshot')}</li>
                    <li>{t('Only one model of implant per submission. You may attach several images of the same implant')}
                    </li>
                </ul>
                <p>{t("For further details, please check out our detailed")} <a href={context.urls.image_submission_guidelines} target={!context.is_embed ? "blank" : ""}>{t('image submission guidelines')}</a>.</p>
            </div>

            <InlineForm label={t("Implant Country")} isRequired={true} helptext={t("Where the implant was placed")}>
                <CountrySelector value={formData.country} onChange={option => setField("country", option && option.value)} />
            </InlineForm>


            <InlineForm label={t("Year")} isRequired={true}>
                <YearSelector value={formData.year} onChange={option => setField("year", option && option.value)} isDisabled={yearUnknown} />
                <small className="form-text text-muted">{t("When the implant was placed (if known)")}</small>
                <div className="custom-control custom-checkbox">
                    <input type="checkbox" name="year_unknown" className="checkboxinput custom-control-input" id="id_year_unknown" checked={yearUnknown} onChange={(e) => onYearUnknownChange(e.target.checked)} />
                    <label className="custom-control-label" htmlFor='id_year_unknown'>
                        {t('Year unknown')}
                    </label> <div className="invalid-feedback"></div>
                </div>
                {yearUnknown ? <>
                    <p className="text-danger">{t('Please at least provide an estimate:')}</p>
                    <YearRangeSelector value={formData.year_range} onChange={option => setField("year_range", option && option.value)} />

                </> : ''}
            </InlineForm>


            <InlineForm label={t("Connection Shape")} isRequired={false} helptext={t('Anti-rotational shape of the abutment-implant interface (if visible)')}>
                <ConnectionShapeSelector value={formData.connection_shape} onChange={option => setField("connection_shape", option && option.value)} />
            </InlineForm>


            <InlineForm label={t("Screwdriver Shape")} isRequired={false} helptext={t('Shape of the screwdriver (if visible). Some brands use specific screwdriver shapes, this can help with the identification.')}>
                <ScrewdriverShapeSelector value={formData.screwdriver_shape} onChange={option => setField("screwdriver_shape", option && option.value)} />
            </InlineForm>

            <InlineForm label={t("Site number")} isRequired={false} helptext={t('Site number of the implant to identify')}>
                {formData.site_}
                <input className="textinput textInput form-control" type="text" value={formData.site_number} onChange={e => setField("site_number", e.target.value)} />
            </InlineForm>

            <InlineForm label={t("Comment")} isRequired={false} helptext={t('Any additional information that may help.')}>
                <textarea name="comment" cols="40" rows="3" className="textarea form-control" value={formData.comment} onChange={e => setField("comment", e.target.value)} ></textarea>
            </InlineForm>

            {!context.user_id ?
                <InlineForm label={t("Email")} isRequired={true}>
                    <input type="email" name="email" maxLength="254" className="emailinput form-control" value={formData.email} onChange={e => setField("email", e.target.value)} />
                </InlineForm>
                :
                <>
                    <InlineForm label={t("Contact Email")} isRequired={true}>
                        <input type="email" name="email" maxLength="254" className="emailinput form-control" value={formData.email} onChange={e => setField("email", e.target.value)} />
                        <small className="form-text text-muted">{t('The email where the identification results will be sent.')}</small>
                        <span
                            id="identification-badge-helper"
                            onClick={() => { setField("email", context.user_email); }}
                            className='badge badge-light badge-pill'>
                            {context.user_email}
                        </span>
                    </InlineForm>
                </>
            }
            <hr />
            <div className="row align-items-center">
                <div className="col-md-5">

                    {!context.user_id ?
                        <small className="text-muted">{t('By clicking on continue, I agree to the')} <a href="/en/terms-and-conditions/" target={!context.is_embed ? "blank" : ""} >{t('terms of use')}</a>.</small>
                        : ''}

                </div>
                <div className={"col-md-7 identification-buttons" + (context.user_id ? " col-md-12" : '')} >
                    {window.history && window.history.back ? <button onClick={() => { window.history.back(); }} className="btn btn-light btn-lg">‹ &nbsp; {t('Back')}</button> : ''}
                    <ButtonWithSpinner
                        onClick={onSubmit}
                        disabled={formDisabled || isSubmitting || (isDemo && !context.is_staff)}
                        isLoading={isSubmitting} >
                        {instance.id ? t("Save Changes") : t('Continue')}
                    </ButtonWithSpinner>

                    {isDemo && !context.is_staff ? <p><small class="text-danger mt-3"> This is a demo, can't submit a request</small></p> : ""}
                </div>
            </div>
        </div>
    </div >;
};


const ButtonWithSpinner = (props) => {
    return <button
        type="submit"
        className="btn btn-lg btn-primary"
        {...props}
        style={{ padding: ".5rem .7rem" }}
    >

        {props.isLoading ? <BsSpinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
            style={{
                position: "relative",
                top: "-2px",
                left: "-4px",
            }}
        /> : <span style={{ display: 'inline-block', width: '1rem' }} />}
        {props.children}
        <span className="btn-right-icon"> &nbsp; ›</span>
        <span style={{ display: 'inline-block', width: '0.7rem' }} />
    </button>;
};

export default IdentificationForm;


const formatRemoteImage = instance => {
    return fetch(instance.img).then(res => res.blob()).then(blob => {

        let objectURL = URL.createObjectURL(blob);
        var f = new File([blob], instance.name);
        f.blob = objectURL;
        f.id = instance.id;

        f.tags = instance.tags;
        f.bboxes = instance.bboxes;
        return f;
    });
};


const QualityWarning = ({ tags, showMultipleWarning, onClose }) => {

    const { t } = useTranslation();
    const errorMessages = {
        "blurry": {
            "title": t("Unclear image"),
            "message": t(`The radiograph seems to be too blurry or not perpendicular, which may affect the identification results. Please try to make your radiograph as perpendicular to the long - axis of the implant as you possibly can.`),
        },
        "cut": {
            "title": t("Implant not entirely visible"),
            "message": t("the radiograph doesn't seem to show the implant entirely. Please include at least one radiograph showing the implant from head to apex.")
        },
        "multiple": {
            "title": t("Multiple implants detected"),
            "message": t(`The radiograph seems to contain several implants, while our system may only identify 1 model of implant at a time (but several implants of the same model is fine). Click on the implants you want to identify.`),
        },
        "not_xray": {
            "title": t("Not a Radiograph"),
            "message": t(`The image you submitted doesn't appear to be a radiograph. Spotimplant is designed to work on periapical x-ray images. You may still submit additional intraoral clinial images, pictures of the abutment or screw, but you should submit at least one radiograph.`),

        },
        "panoramic": {
            "title": t("Panoramic"),
            "message": t(`The radiograph you submitted appears to be a panoramic x-ray. We prefer intraoral periapical radiographs as they show more details of the implant.`)
        },

        "screenshot": {
            "title": t("Screenshot"),
            "message": t(`The radiograph you submitted appears to be a screenshot taken from a smartphone. Please export the image directly from the imaging software.`)
        }
    };

    var body;

    var IGNORED_TAGS = ["screenshot"];

    const generateBody = tags => {
        if (tags.includes("not_xray")) {
            const errorMessageData = errorMessages["not_xray"];
            return <><h3>{errorMessageData.title}</h3><p>{errorMessageData.message}</p></>;
        }



        return <>
            <p>{displayedTags.length > 1 ? t("We have detected some issues with your image") : t("We have detected an issue with your image")}:</p>

            <ul>
                {displayedTags.map(tag => <li><b>{errorMessages[tag].title}</b>: {errorMessages[tag].message}</li>)}
            </ul>
        </>;

    };

    const displayedTags = tags.filter(x => !IGNORED_TAGS.includes(x) && showMultipleWarning || x != "multiple");


    body = generateBody(displayedTags);


    const [show, setShow] = useState(Boolean(body));

    useEffect(() => {
        const body = generateBody(tags);
        if (Boolean(body) != show) {
            setShow(Boolean(body));
        }
    }, [tags]);


    if (!displayedTags || displayedTags.length === 0) {
        return '';
    }

    const handleClose = () => {
        setShow(false);
        onClose();
    };
    const handleShow = () => setShow(true);

    return (

        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className="text-primary"><i className="fas fa-exclamation-triangle"></i> {t('Issue detected')}


                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{body}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t('I understand')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

};

